import React from "react"
import ReactDOM from "react-dom"
import TestimonialContainer from "./testimonial-container-component"

export default class TestimonialContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<TestimonialContainer {...self.modelJson} />, self.elem)
  }
}
